var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((5),function(i){return _c('span',{key:`star-quality-${i}`},[(i <= _vm.quality.stars)?_c('i',{staticClass:"fa fa-star text-dark me-0"}):_vm._e(),(i > _vm.quality.stars)?_c('i',{staticClass:"fal fa-star text-dark me-0"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }